import { Injectable } from '@angular/core';
import { Langs } from './translation.service';
import { LocalStorageService } from './local-storage.service';

export enum Countries {
  Korea = 'KR',
  Russia = 'RU',
  Default = 'EN',
}

@Injectable({
  providedIn : 'root',
})
export class RedirectService {

  constructor(private localStorageService: LocalStorageService) {
  }

  public goToYandex(): void {
    this.localStorageService.setItem('country-changed-manually', JSON.stringify(true));
    this.changeLocation(`/intl/${Langs.Russian}_${Countries.Russia}/`);
  }

  public goToNaver(language: string): void {
    if (language === `${Langs.Korean}_${Countries.Korea}`) {
      this.localStorageService.setItem('lang', `${Langs.Korean}_${Countries.Korea}`);
    }
    this.changeLocation(`/intl/${language}/`);
  }

  public changeLocation(newLocation: string): void {
    window.location.href = newLocation;
  }
}
